import { useEffect, useState } from 'react';
import { DL_QUERY_STRINGS } from '../../../constants/dealerLocator.constants';
import { TCountry } from '../types/dealerLocatorLanding.types';
import { windowService } from '../../../utils/window.utils.js';

const useCountry = (defaultValue, model): [TCountry | null, React.Dispatch<React.SetStateAction<TCountry | null>>] => {
  const getQuery = (key: string) => new URLSearchParams(windowService().location?.search).get(key);
  const query = getQuery(DL_QUERY_STRINGS.COUNTRY);
  const countryFromQuery = model.countries.find((country) => country.IsoCode === query) ?? null;
  const [country, setCountry] = useState<TCountry | null>(countryFromQuery || defaultValue);
  const [countryIsoCode, setCountryIsoCode] = useState<string>('');

  useEffect(() => {
    if (!query || !countryFromQuery || query === countryIsoCode) {
      return;
    }

    setCountry(countryFromQuery);
  }, [query, countryFromQuery, country]);

  useEffect(() => {
    setCountryIsoCode(country?.IsoCode ?? '');
  }, [country]);

  return [country, setCountry];
};

export default useCountry;
